var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternalLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#3f8ad1;}.cls-3{fill:#3475ae;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1336",
    "data-name": "Ellisse 1336"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.5,
    cy: 12.5,
    r: 12.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.52,12.52,0,0,1,12.5,25ZM12.5.92A11.58,11.58,0,1,0,24.08,12.5,11.59,11.59,0,0,0,12.5.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.67,8.33a2.59,2.59,0,0,0-3.55-1L13.45,9.49a2.6,2.6,0,0,0-3-.33l-5.16,3A2.61,2.61,0,0,0,6.55,17a2.57,2.57,0,0,0,1.3-.35l3.66-2.11a2.52,2.52,0,0,0,1.08.58,2.59,2.59,0,0,0,.68.09,2.48,2.48,0,0,0,1.29-.35l5.16-3a2.65,2.65,0,0,0,1.22-1.58A2.58,2.58,0,0,0,20.67,8.33Zm-7.24,3.55A1.79,1.79,0,0,1,12.6,13l-.9.51a1.78,1.78,0,0,1,.67-2.42l.89-.52A1.79,1.79,0,0,1,13.43,11.88ZM7.44,16a1.79,1.79,0,0,1-1.79-3.1l5.16-3a1.79,1.79,0,0,1,1.88.06l-.73.42a2.6,2.6,0,0,0-1,3.54Zm12.71-5.86a1.77,1.77,0,0,1-.84,1.09l-5.15,3a1.8,1.8,0,0,1-1.36.18,2,2,0,0,1-.53-.24l.73-.42a2.61,2.61,0,0,0,1-3.55l3.55-2.05A1.79,1.79,0,0,1,20,8.74,1.77,1.77,0,0,1,20.15,10.09Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalLink);
export default __webpack_public_path__ + "static/media/internal_link.26668e7d72d2a386f0bc896dd9cbb1c2.svg";
export { ForwardRef as ReactComponent };